module.exports = __webpack_public_path__ + "media/images/icons/class-icon-23e76df6648bf2b08c505404c80c8db8.svg";